import * as React from 'react';
import cx from 'classnames';
import {CheckBox, Button, Flex} from '@priority-software/priority-style-react';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import {SearchOptions, ChooseOptions, StatusCircle} from '../../../components/Common/FieldSearch';
import {FieldSearchDropdownProps} from '../../../components/Common/FieldSearch/types/DropdownProps';
import dropdownPartsStyle from '../../../components/Common/FieldSearch/components/SearchParts/styles.module.scss';
import styles from '../styles/FieldSearch.module.scss';
import {Label} from '../../../components/Common/Label';
import {ReactNode, useCallback} from 'react';

export const DropdownContent = (props: FieldSearchDropdownProps) => {
    const {isLoading, isSearchable, hasStatus} = props;
    const statusRenderer = useCallback((status: string) => <StatusCircle status={status} />, []);

    return (
        <>
            {!isLoading && (
                <>
                    {isSearchable ? (
                        <SearchDropdownContent {...props} />
                    ) : (
                        <ChooseDropdownContent
                            {...props}
                            statusRenderer={hasStatus ? statusRenderer : undefined}
                        />
                    )}
                </>
            )}
        </>
    );
};

export const ChooseDropdownContent = (
    props: FieldSearchDropdownProps & {statusRenderer?: (status: string) => ReactNode}
) => {
    return (
        <>
            <ChooseOptions {...props} />
            {props.isMulti && (
                <div className={cx(dropdownPartsStyle.searchFooter, styles.searchFooter)}>
                    <Button width="regularFixed" onClick={props.onMultiSelect}>
                        {getLocalizedText(texts.ok)}
                    </Button>
                </div>
            )}
        </>
    );
};

const Footer = (props: FieldSearchDropdownProps) => {
    const {
        ignorecase,
        onIgnoreCaseChange,
        searchFromBeginning,
        onSearchFromBeginningChange,
        onMultiSelect,
        isMulti
    } = props;
    return (
        <div className={cx(dropdownPartsStyle.searchFooter, styles.searchFooter)}>
            <Flex justifyContent="flex-start">
                <CheckBox checked={ignorecase} onChange={onIgnoreCaseChange}>
                    <Label skin="caption-2">{getLocalizedText(texts.ignorecase)}</Label>
                </CheckBox>
                <CheckBox
                    checked={searchFromBeginning}
                    onChange={onSearchFromBeginningChange}
                    componentClasses={styles.checkbox}
                >
                    <Label skin="caption-2">{getLocalizedText(texts.searchFromBegining)}</Label>
                </CheckBox>
            </Flex>
            {isMulti && (
                <Button width="regularFixed" onClick={onMultiSelect}>
                    {getLocalizedText(texts.ok)}
                </Button>
            )}
        </div>
    );
};

export const SearchDropdownContent = (props: FieldSearchDropdownProps) => {
    return (
        <>
            <SearchOptions {...props} />
            <Footer {...props} />
        </>
    );
};
